module.exports = __webpack_public_path__ + "img/Nav Logo.2d468638.jpg";